export default {"src":"/_next/static/media/SNDL.6c9a492b.svg","height":18,"width":18};